import axios from "../axios-auth";

export const materialSessionService = {
    getMaterialSessionList,
    saveMaterialSession,
    getMaterialSessionDetail,
    getMaterialSessionsByStatus,
};

function getMaterialSessionList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/material-sessions", { params });
}

function saveMaterialSession(materialSession) {
    if (!materialSession.id) {
        // new 
        return axios.post("/auth/material-session", materialSession);
    } else {
        // edit
        return axios.put("/auth/material-session", materialSession);
    }
}

function getMaterialSessionDetail(id) {
    return axios.get("/auth/material-session/" + id);
}

function getMaterialSessionsByStatus(status) {
    return axios.get("/auth/material-sessions-by-status/" + status);
}
